// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  width: 17.1875rem;
}
.dropdown_open .dropdown-header {
  border-bottom: 1px solid rgba(var(--blue-grey-300));
}
.dropdown_open .dropdown-header-title {
  text-decoration-color: rgba(var(--black));
}
.dropdown_mobile {
  width: auto;
}
.dropdown_mobile .dropdown-header {
  border-bottom: none;
}
.dropdown_mobile .dropdown-header-title {
  text-decoration-color: rgba(var(--white));
}
.dropdown_mobile .dropdown-list {
  max-height: 100%;
}
.dropdown_mobile .dropdown-list__scroll {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: calc(100svh - 160px);
}
.dropdown_mobile .dropdown-list-item_simple {
  margin-right: 0;
}
.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(var(--white));
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  height: 2rem;
}
.dropdown-header-title {
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 600;
  color: rgba(var(--grey-800));
  transition: all 0.3s ease-in-out;
  text-decoration: underline;
  text-underline-offset: 10px;
  text-decoration-thickness: 1px;
  text-decoration-color: rgba(var(--white));
}
.dropdown-header-icon {
  transition: transform 0.5s;
}
.dropdown-header-icon_open {
  transform: rotateX(180deg);
  transition: transform 0.5s;
}
.dropdown-list {
  margin-top: 1rem;
  opacity: 1;
  max-height: 304px;
  transition: all 1s;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.dropdown-list_hidden {
  opacity: 0;
  transition: all 0.5s cubic-bezier(0, 1, 0, 1);
  max-height: 0px !important;
  margin-top: 0px;
}
.dropdown-list_hidden .dropdown-list-item {
  overflow: hidden;
}
.dropdown-list_hidden .dropdown-list__search {
  height: 0px;
}
.dropdown-list_multiple {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.dropdown-list-item {
  font-size: 0.875rem;
  line-height: 1.57;
  color: rgba(var(--grey-800));
  transition: all 0.5s;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.dropdown-list-item_simple {
  margin-right: 0.75rem;
  padding: 0.5rem;
}
.dropdown-list-item_selected {
  font-weight: 600;
  transition: all 0.1s;
  background-color: rgba(var(--grey-100));
}
.dropdown-list-item__check {
  margin-right: 0.47rem;
}
.dropdown-list__scroll {
  overflow-y: auto;
  overflow-x: hidden;
  mask-image: none;
}
.dropdown-list__scroll_mask {
  mask-image: linear-gradient(rgba(var(--white)) 88%, transparent);
  will-change: mask-image;
}
.dropdown-list__search {
  margin-bottom: 1rem;
}

[data-filter=brand] .dropdown_mobile .dropdown-list__scroll {
  height: calc(100svh - 230px);
}`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAEI;EACE,mDAAA;AAAN;AAEM;EACE,yCAAA;AAAR;AAKE;EACE,WAAA;AAHJ;AAKI;EACE,mBAAA;AAHN;AAKM;EACE,yCAAA;AAHR;AAOI;EACE,gBAAA;AALN;AAOM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;AALR;AAQM;EACE,eAAA;AANR;AAWE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,2CAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;AATJ;AAWI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yCAAA;AATN;AAYI;EACE,0BAAA;AAVN;AAYM;EACE,0BAAA;EACA,0BAAA;AAVR;AAeE;EACE,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAbJ;AAeI;EACE,UAAA;EACA,6CAAA;EACA,0BAAA;EACA,eAAA;AAbN;AAeM;EACE,gBAAA;AAbR;AAgBM;EACE,WAAA;AAdR;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAhBN;AAmBI;EACE,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAjBN;AAmBM;EACE,qBAAA;EACA,eAAA;AAjBR;AAoBM;EACE,gBAAA;EACA,oBAAA;EACA,uCAAA;AAlBR;AAqBM;EACE,qBAAA;AAnBR;AAuBI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AArBN;AAuBM;EACE,gEAAA;EACA,uBAAA;AArBR;AAyBI;EACE,mBAAA;AAvBN;;AA8BI;EACE,4BAAA;AA3BN","sourcesContent":[".dropdown {\n  width: 17.1875rem;\n\n  &_open {\n    .dropdown-header {\n      border-bottom: 1px solid rgba(var(--blue-grey-300));\n\n      &-title {\n        text-decoration-color: rgba(var(--black));\n      }\n    }\n  }\n\n  &_mobile {\n    width: auto;\n\n    .dropdown-header {\n      border-bottom: none;\n\n      &-title {\n        text-decoration-color: rgba(var(--white));\n      }\n    }\n\n    .dropdown-list {\n      max-height: 100%;\n\n      &__scroll {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        height: calc(100svh - 160px);\n      }\n\n      &-item_simple {\n        margin-right: 0;\n      }\n    }\n  }\n\n  &-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    border-bottom: 1px solid rgba(var(--white));\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n    height: 2rem;\n\n    &-title {\n      font-size: 1rem;\n      line-height: 1.625;\n      font-weight: 600;\n      color: rgba(var(--grey-800));\n      transition: all 0.3s ease-in-out;\n      text-decoration: underline;\n      text-underline-offset: 10px;\n      text-decoration-thickness: 1px;\n      text-decoration-color: rgba(var(--white));\n    }\n\n    &-icon {\n      transition: transform 0.5s;\n\n      &_open {\n        transform: rotateX(180deg);\n        transition: transform 0.5s;\n      }\n    }\n  }\n\n  &-list {\n    margin-top: 1rem;\n    opacity: 1;\n    max-height: 304px;\n    transition: all 1s;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n\n    &_hidden {\n      opacity: 0;\n      transition: all 0.5s cubic-bezier(0, 1, 0, 1);\n      max-height: 0px !important;\n      margin-top: 0px;\n\n      .dropdown-list-item {\n        overflow: hidden;\n      }\n\n      .dropdown-list__search {\n        height: 0px;\n      }\n    }\n\n    &_multiple {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n    &-item {\n      font-size: 0.875rem;\n      line-height: 1.57;\n      color: rgba(var(--grey-800));\n      transition: all 0.5s;\n      padding: 0.5rem 0;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      cursor: pointer;\n\n      &_simple {\n        margin-right: 0.75rem;\n        padding: 0.5rem;\n      }\n\n      &_selected {\n        font-weight: 600;\n        transition: all 0.1s;\n        background-color: rgba(var(--grey-100));\n      }\n\n      &__check {\n        margin-right: 0.47rem;\n      }\n    }\n\n    &__scroll {\n      overflow-y: auto;\n      overflow-x: hidden;\n      mask-image: none;\n\n      &_mask {\n        mask-image: linear-gradient(rgba(var(--white)) 88%, transparent);\n        will-change: mask-image;\n      }\n    }\n\n    &__search {\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n[data-filter='brand'] {\n  .dropdown_mobile {\n    .dropdown-list__scroll {\n      height: calc(100svh - 230px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
